"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buffer_1 = require("buffer");
var File = /** @class */ (function () {
    function File(id, name, data, meta) {
        this.id = id;
        this.name = name;
        this.data = data;
        this.meta = meta;
    }
    // base64 string for forcing a file download.
    File.prototype.base64DownloadString = function () {
        return "data:application/octet-stream;base64," + this.getBase64Data();
    };
    // base64 string for feeding into a browser URL.
    File.prototype.base64ViewString = function () {
        return "data:" + this.meta.mime + ";base64," + this.getBase64Data();
    };
    // return json-serialized file
    File.prototype.serialize = function () {
        return {
            id: this.id,
            name: this.name,
            data: this.data,
            meta: this.meta,
        };
    };
    File.prototype.rawObject = function () {
        return {
            id: this.id,
            name: this.name,
            data: buffer_1.Buffer.from(this.data, 'base64'),
            meta: this.meta
        };
    };
    File.prototype.getName = function () {
        if (!this.name) {
            return "file-" + this.id;
        }
        return this.name;
    };
    File.prototype.getBase64Data = function () {
        return this.data;
    };
    File.isReadable = function (mime) {
        if (/text\//.test(mime)) {
            return true;
        }
        if (mime == "application/javascript") {
            return true;
        }
        return false;
    };
    // helper method to determine if a file is viewable.
    File.prototype.isReadable = function () {
        return File.isReadable(this.meta.mime);
    };
    return File;
}());
exports.default = File;
;
